import { Money } from "../../utils/money";
import { DriverType } from "../delivery-company/drivers";
import { MerchantType } from "../delivery-company/merchants";
import { OrderType } from "../delivery-company/orders";

export interface TotalAmounts {
  cod: Money[];
  driver_commission: Money[];
  pop: Money[];
  delivery_fee: Money[];
  price: Money[];
  due_to_company: Money[];
}

export const emptyTotalAmounts: TotalAmounts = {
  cod: [],
  driver_commission: [],
  delivery_fee: [],
  price: [],
  pop: [],
  due_to_company: []
}


export enum InvoiceMetaState {
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PAYMENT_SCHEDULED = "PAYMENT_SCHEDULED",
  IN_PROGRESS = "IN_PROGRESS",
  PAID = "PAID",
  FAILED = "FAILED",
  CANCELLED = "Cancelled"
}

